<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="items"
      :total-items="total"
      :loading="loading"
      :pagination="pagination"
      :rows-per-page-items="[10, 25, 50]"
      @update:pagination="$emit('update:pagination', $event)"
    >
      <template #items="{ item }">
        <tr class="cursor-pointer" @click="$emit('view', item)">
          <template v-if="app === 'facebook'">
            <td class="text-xs-right">{{ item.totalUsers | numberFormat }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.subCode }}</td>
            <td>{{ item.message }}</td>
          </template>
          <template v-else-if="app === 'line'">
            <td class="text-xs-right">{{ item.totalUsers | numberFormat }}</td>
            <td>
              <div
                :style="{
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 5
                }"
              >
                {{ item.message }}
              </div>
            </td>
          </template>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    app: {
      type: String,
      default: 'facebook'
    },
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    headers() {
      if (this.app === 'line') {
        return [
          {
            value: 'totalUsers',
            text: 'Total users',
            sortable: false,
            align: 'right'
          },
          {
            value: 'message',
            text: 'Error message',
            sortable: false
          }
        ]
      }

      return [
        {
          value: 'totalUsers',
          text: 'Total users',
          sortable: false,
          align: 'right'
        },
        {
          value: 'type',
          text: 'Error type',
          sortable: false
        },
        {
          value: 'code',
          text: 'Error code',
          sortable: false
        },
        {
          value: 'subCode',
          text: 'Error sub-code',
          sortable: false
        },
        {
          value: 'message',
          text: 'Error message',
          sortable: false
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastHistory/DataTable.vue